import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { PrototypeBanner } from "@/components/PrototypeBanner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, AlertCircle } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata! Ora puoi accedere.");
      navigate("/login");
    } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#EAF3EF] flex flex-col">
      <PrototypeBanner />
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="flex justify-center mb-6"><Logo to="/" /></div>
          <div className="bg-white rounded-2xl border border-[#D2E3DB] shadow-sm p-8">
            <h1 className="text-2xl font-bold text-[#102A2A] mb-2">Nuova password</h1>
            {!token ? (
              <p className="text-sm text-[#C0392B]">Link non valido. <Link to="/login" className="underline">Torna all'accesso</Link></p>
            ) : (
              <>
                <p className="text-sm text-[#5C6B68] mb-6">Inserisci la tua nuova password.</p>
                {error && <div className="mb-4 flex items-start gap-2 bg-[#F9E3E0] border border-[#C0392B]/30 text-[#C0392B] rounded-xl px-4 py-3 text-sm"><AlertCircle className="h-4 w-4 mt-0.5" /> {error}</div>}
                <form onSubmit={submit} className="space-y-4">
                  <div><Label htmlFor="pw">Nuova password</Label><Input id="pw" data-testid="reset-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl mt-1" placeholder="Almeno 8 caratteri" /></div>
                  <Button type="submit" data-testid="reset-submit" disabled={loading} className="w-full bg-[#087A73] hover:bg-[#06615B] text-white rounded-xl h-12 font-semibold">
                    {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Aggiorna password"}
                  </Button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
